import React, { Component } from "react";
import styled from "styled-components";
import { Flex, Link, Button } from "../../components";
import { history } from "../../utils";
import vars from "../../vars";
import Hexagon2 from "../../components/Hexagon2";
import Modal from "./Modal";
import Modal1 from "./Modal1";
import MobileCarousel from '../../components/MobileCarousel/MobileCarousel';
import moment from 'moment';
import 'katex/dist/katex.min.css';
import LayoutWrapper from '../../components/LayoutWrapper';
import Equation from '../../components/Equation';
import Report from '../../components/Report/Report';
import { swipedetect } from '../../lib/swiper';
import Shimmer from '../../components/shimmer';
import {addQuestionBookmark, deleteQuestionBookmark} from '../../lib/api'
import {updateLearningPath, updateEndExamLearningPath} from '../../lib/api'


const Box = styled.div`
  margin: 0 0 0.5em 0;
  padding-top: 0.2em;
  border-radius: 4px;
  background:white;
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
`;

const Image = styled(Flex)`
  height: 15rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Hint = styled(Flex)`
  padding: 0.3em 0;
  span{
    color: #4E54C8;
    font-size: 14px;
    // font-weight: bold;
  },
  svg {
    color: ${vars.brand_color};
    padding: 0.5em 0; 
  }
`;

const QuestionOverviewWrapper = styled.div`
  display:initial;
  @media (max-width: 767px) {
    display: none;
  }
`
const ActionButtons = styled.div`
  @media(max-width:767px){
    display:none;
  }
`

const GridLayout = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 2rem;
  @media (max-width: 768px) {
    grid-template-columns: auto;
  }
`;

const Hex = () => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 300 300">
    <polygon points="300,150 225,280 75,280 0,150 75,20 225,20" />
  </svg>
);

const Hexagon = styled(Flex)`
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 3em;
    height: 3em;
    cursor: pointer;
    text-decoration: none;
    span {
      color: #000;
      z-index: 1;
    }
  }

  svg {
    position: absolute;
    fill: ${({ blue, yellow }) =>
    blue ? "#42A5F5" : yellow ? "#eed94a" : "#ccc"};
    width: 100%;
    height: 100%;
    polygon {
      stroke: ${({ active }) => (active ? vars.brand_color : "transparent")};
      stroke-width: 10px;
      transition: all 0.3s esae;
    }
    transition: all 0.3s esae;
  }
`;

const QuestionsOverview = styled.div`
  display: grid;
  grid-template-columns: repeat(4, auto);
  grid-gap: 1em;
`;

class TestStart extends Component {
  state = {
    modalOpen: false,
    testSubmittedModalOpen: false,
    windowChangeWarningModalOpen: false,
    practice_id: this.props.practice_id,
    unit_id: this.props.unit_id,
    subject_id: this.props.subject_id,
    answers: this.props.questions.map(({ id, type, type_code, type_id }) => ({
      question_id: id,
      question_option_id: null,
      timetaken: [],
      screenshot: 0,
      isBookMarked: false,
      type: type,
      type_code: type_code,
      type_id: type_id
    })),
    offline: false,
    visitedTimeStamp: null,
    questionVisitDuration: 0,
    reportDialogOpened: false,
    dialogTitle: 'Are you sure you want to submit the test ?',
    showShimmer: false,
    testSubmittedFromMulitpleFraud:false,
    pageMounted:false,
    event:null,
    noOfWindowSwitches:0,
    visible : true
  };

  updateScrollStates(event, pageX) {
    pageX = event && event.pageX || pageX;
    if (!event && !pageX) return;
    let width = window.innerWidth;
    let center = width / 2;
    let difference = pageX - center;
    let scrollbleElement = document.getElementById('mobile-scroller');
    scrollbleElement.scrollBy({
      left: difference,
      behavior: 'smooth'
    });
    localStorage.setItem('lastX', pageX);
    localStorage.setItem('lastScrollLeftPosition', scrollbleElement.scrollLeft);
  }

  onQuestionClick(qid, i, event, pageX) {
    try {
      if (event && qid !== i) {
        this.setState({ showShimmer: true })
        setTimeout(() => {
          this.setState({ showShimmer: false })
        }, 125)
      }
      this.updateScrollStates(event, pageX);
      let datetime = moment().format('YYYY-MM-DD hh:mm:ss').toString();
      let { tid, questions } = this.props;
      this.setState(prevState => {
        let question = prevState.answers.find(
          ({ question_id }) => question_id === questions[qid].id
        );
        let timetaken;
        if (typeof (question.timetaken) == "string") timetaken = JSON.parse(question.timetaken);
        else timetaken = question.timetaken;
        if (timetaken.length > 0) {
          timetaken.push([prevState.visitedTimeStamp, datetime, prevState.questionVisitDuration]);
        } else {
          timetaken = [[prevState.visitedTimeStamp, datetime, prevState.questionVisitDuration]];
        }
        question.timetaken = timetaken;
        return prevState;
      });
      this.setState(prevState => {
        prevState.visitedTimeStamp = datetime;
        prevState.questionVisitDuration = 0;
        return prevState;
      });
    } catch (error) {
      console.log(error);
    }
  }

  checkNative = () => {
    try {
      if ((window.webkit) || window.appInterface)
        return true;
      else return false;
    } catch (error) {
      console.log(error);
    }
  }

  callbackToNative = (msg) => {
    console.log('calling back native' + msg)
      try {
        if (window.webkit != undefined) {
          window.webkit.messageHandlers.observe.postMessage(msg);
          window.webkit.messageHandlers.appInterface.postMessage(msg)
        }
        if (window.appInterface != undefined) {
          window.appInterface.postMessage(msg)
        }
      } catch (error) {
        console.log(msg);
        console(error);
    }
  }



  handleSubmit = async () => {
    try {
      if (this.state.offline) {
        this.callbackToNative("done");
        this.setState({ modalOpen: false });
        return;
      }
      if (this.state.testSubmitting) return;
      let practice_type = localStorage.getItem('practice_type')
      this.setState({ testSubmitting: true });
      clearInterval(this.intervalId);
      let { submitTest, tid, qid } = this.props;
      await this.onQuestionClick(qid);
      this.setState({ practice_id: this.props.practice_id });
      let success = await submitTest({ ...this.state });
      if (success && practice_type == 'learning_practice_test') {
        let success1 = await updateLearningPath(this.props.practice_id, this.props.subject_id);
        console.log(success1);
      }
      if (success && practice_type == 'end_exam_practice_test') {
        let success1 = await updateEndExamLearningPath(this.props.practice_id);
        console.log(success1);
      }
      this.setState({ testSubmitting: false });
      localStorage.setItem('practiceState', JSON.stringify(this.state));
      localStorage.setItem('practiceTestProps', JSON.stringify(this.props));
      if (success) {
        if(this.state.testSubmittedFromMulitpleFraud) {
          localStorage.removeItem('lastX');
          localStorage.removeItem('lastScrollLeftPosition');
          this.removeEventListeners()
          return;
        }
        let bool = this.checkNative();
        localStorage.removeItem('lastX');
        localStorage.removeItem('lastScrollLeftPosition');
        this.removeEventListeners()
        history.push(`/practiceTestOverview`);
      } else {
        alert("Something goes wrong, please submit again!");
      }
    } catch (error) {
      this.setState({ testSubmitting: false });
      console.log(error);
    }
  };

  removeEventListeners = () =>{
    console.log('removing listeners')
    // window.removeEventListener('beforeunload',(event)=> this.beforeUnloadFunction(event))
    // document.removeEventListener('beforeunload', this.beforeUnloadFunction)
    // window.removeEventListener('beforeunload', this.beforeUnloadFunction)
    // window.removeEventListener('beforeunload', this.beforeUnloadFunction)
    // window.removeEventListener('beforeunload', this.beforeUnloadFunction)
    // window.onbeforeunload = null
    window.removeEventListener('pagehide', this.unfocused)
    window.removeEventListener('pageshow', this.focused)
    window.removeEventListener('focus', this.focused)
    window.removeEventListener('blur', this.unfocused)
    window.onblur = null
    window.onfocus = null
    window.onpagehide = null
    window.onpageshow = null
    if ('onfocusin' in document) {
      document.onfocusin = null
      document.onfocusout = null
    }
    document.removeEventListener('focusin', this.focused)
    document.removeEventListener('focusout', this.unfocused)
    if ('hidden' in document) {
      document.removeEventListener('visibilitychange', this.visiblityChangeFunction)
    }
    if ('mozHidden' in document) {
      document.removeEventListener('mozvisibilitychange', this.mozVisiblityChangeFunction)
    }
    if ('webkitHidden' in document) {
      document.removeEventListener('webkitvisibilitychange', this.webkitVisiblityChangeFunction)
    }
    if ('msHidden' in document) {
      document.removeEventListener('msvisibilitychange', this.msVisiblityChangeFunction)
    }
  }

  handleModalToggle = () => {
    if (this.state.offline) {
      this.setState({
        dialogTitle: 'Your not connected to active internet.',
        modalOpen: true
      });
      return;
    } else {
      this.setState({ modalOpen: !this.state.modalOpen, dialogTitle: 'Are you sure you want to submit the test ?' });
    }
  };

  handleBookMark = () => {
    let { tid, qid, questions } = this.props;
    this.setState(prevState => {
      let question = prevState.answers.find(
        ({ question_id }) => question_id === questions[qid].id
      );
      question.question_option_id = null;
      question.isBookMarked = true;
      return prevState;
    });
  };

  updateTimers = () => {
    this.setState(prevState => {
      let datetime = moment().format('YYYY-MM-DD hh:mm:ss').toString();
      if (!prevState.visitedTimeStamp) {
        prevState.visitedTimeStamp = datetime
      };
      prevState.total_timetaken = prevState.total_timetaken + 1;
      prevState.questionVisitDuration = prevState.questionVisitDuration + 1
      return prevState;
    });
  }

  handleCheck = (id, is_answer) => {
    let { tid, qid, questions } = this.props;
    this.setState(prevState => {
      let question = prevState.answers.find(
        ({ question_id }) => question_id === questions[qid].id
      );
      if (question.question_option_id) {
        return
      }
      question.question_option_id = id;
      question.isBookMarked = false;
      question.is_answer = is_answer;
      return prevState;
    });
  };

  componentWillMount() {
    localStorage.removeItem('lastX');
    localStorage.removeItem('lastScrollLeftPosition');
  }



  componentDidMount = () => {
    window.addEventListener("online", () => {
      this.setState({ offline: false });
    }, false);
    window.addEventListener("offline", () => {
      this.setState({ offline: true });
    }, false);
    document.body.style.background = 'white';
    this.askBeforeUserLeaving();
    document.body.style.overflow = 'hidden';
    var input = {
      year: 0,
      month: 0,
      day: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };

    var timestamp = new Date(input.year, input.month, input.day,
      input.hours, input.minutes, input.seconds);

    var interval = 1;

    this.intervalId = setInterval(() => {
      timestamp = new Date(timestamp.getTime() + interval * 1000);
      if (document.getElementById('countdown2')) {
        let hours = timestamp.getHours();
        let mins = timestamp.getMinutes();
        let secs = timestamp.getSeconds();
        document.getElementById('countdown2').innerHTML = hours ? (hours < 10 ? '0' + hours : hours) + ':' + (mins< 10 ? '0'+mins : mins) + ':' + (secs<10 ? '0' + secs : secs) : (mins< 10 ? '0'+mins : mins) + ':' + (secs<10 ? '0' + secs : secs);
        this.updateTimers();
      } else {
        clearInterval(this.intervalId);
      }
    }, Math.abs(interval) * 1000);
    var self = this;
    var el = document.getElementById('questionArea')
    swipedetect(el, function (swipedir) {
      if (swipedir == 'left' || swipedir == 'right') {
        self.onLeftorRightSwipe(swipedir);
      }
      if (swipedir == 'top' || swipedir == 'down') {
        console.log('up or down');
      }
    });
  }

  onVisibilityChangeCallBack = (visible) =>{
    if(!visible){
      console.log('visibility changes')
      console.log(this.state.noOfWindowSwitches)
      if (this.state.noOfWindowSwitches == 0) {
        this.setState({noOfWindowSwitches : this.state.noOfWindowSwitches+1})
        console.log("Warning: You are NOT allowed to switch apps during the test! ");
        this.setState({windowChangeWarningModalOpen: true, dialogTitle: 'Warning: You are NOT allowed to switch apps during the test! '})
      } else {
        console.log("Warning: You are NOT allowed to switch apps during the test! ");
        this.setState({testSubmittedFromMulitpleFraud:true});
        this.handleSubmit()
        this.setState({testSubmittedModalOpen: true, dialogTitle: 'Your Test has been submitted!!',windowChangeWarningModalOpen: false})
      }
      // } 
    }
    console.log('the page is now', visible ? 'focused' : 'unfocused');
  }

  askBeforeUserLeaving(){
    try {
      let pathname,array = [];
      this.onVisibilityChange(this.onVisibilityChangeCallBack);
    } catch (error) {
      console.log(error);
    }
    // window.addEventListener("beforeunload",(event)=> this.beforeUnloadFunction(event));
  }

  // beforeUnloadFunction = (e) => {
  //   console.log(e)
  //   e.preventDefault()
  //   e.stopPropagation()
  //   var confirmationMessage = 'It looks like you have been editing something. '
  //                           + 'If you leave before saving, your changes will be lost.';

  //   (e || window.event).returnValue = confirmationMessage; //Gecko + IE
  //   return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
  // }

  focused = (callback) => {
    if (!this.state.visible) {
      this.setState({visible : true})
      callback( true);
    }
  }

  unfocused = (callback) => {
    if (this.state.visible) {
      this.setState({visible: false})
      callback( false);

    }
  }

  mozVisiblityChangeFunction = (callBack) => {
      (document.mozHidden ? this.unfocused : this.focused)(callBack)
  }
  visiblityChangeFunction = (callBack) => {
      (document.hidden ? this.unfocused : this.focused)(callBack)
  }
  webkitVisiblityChangeFunction = (callBack) => {
      (document.webkitHidden ? this.unfocused : this.focused)(callBack)
  }
  msVisiblityChangeFunction = (callBack) => {
      (document.msHidden ? this.unfocused : this.focused)(callBack)
  }

  onVisibilityChange(callback) {
    var visible = true;

    if (!callback) {
        throw new Error('no callback given');
    }

    // Standards:
    if ('hidden' in document) {
        document.addEventListener('visibilitychange',() => this.visiblityChangeFunction(callback));
    }
    if ('mozHidden' in document) {
        document.addEventListener('mozvisibilitychange',()=> this.mozVisiblityChangeFunction(callback));
    }
    if ('webkitHidden' in document) {
        document.addEventListener('webkitvisibilitychange',()=>this.webkitVisiblityChangeFunction(callback));
    }
    if ('msHidden' in document) {
        document.addEventListener('msvisibilitychange',()=>this.msVisiblityChangeFunction(callback));
    }
    // IE 9 and lower:
    if ('onfocusin' in document) {
        document.onfocusin = () =>this.focused(callback);
        document.onfocusout = () =>this.unfocused(callback);
    }
    // All others:
    window.onpageshow = window.onfocus = ()=>this.focused(callback);
    window.onpagehide = window.onblur = ()=>this.unfocused(callback);
  };

  testSubmittedOnLeavingWindow = () =>{
    let bool = this.checkNative()
    localStorage.removeItem('lastX');
    localStorage.removeItem('lastScrollLeftPosition');
    history.push(`/practiceTestOverview`);
  }

  windowChangeWarningModalClose = () =>{
    if (this.state.offline) {
      this.setState({
        dialogTitle: 'Your not connected to active internet.',
        modalOpen: true
      });
      return;
    } else {
      this.setState({ windowChangeWarningModalOpen: false, dialogTitle: '' });
    }
  }
  onLeftorRightSwipe = (swipedir) => {
    let { qid, search, questions } = this.props;
    let swipeDistance;
    if (swipedir === 'left' && qid == questions.length - 1) return;
    if (swipedir === 'right' && qid == 0) return;
    this.setState({ showShimmer: true })
    setTimeout(() => {
      this.setState({ showShimmer: false })
      if (swipedir === 'left') {
        swipeDistance = window.innerWidth * 3 / 4;
        history.push(`/practiceTest/${parseInt(qid) + 1}${search}`);
      } else {
        swipeDistance = window.innerWidth / 4;
        history.push(`/practiceTest/${parseInt(qid) - 1}${search}`);
      }
      this.onQuestionClick(parseInt(qid), null, null, swipeDistance);

    }, 100)
  }

  addOrDeleteBookmark = async () => {
    let is_bookmarked = this.props.questions[this.props.qid].is_bookmarked;
    let id = this.props.questions[this.props.qid].id
    if (is_bookmarked === 0) {
      let response = await addQuestionBookmark(id);
      if (response.status === 200) {
        this.props.questions[this.props.qid].is_bookmarked = 1
      }
    } else if(is_bookmarked === 1) {
      let response = await deleteQuestionBookmark(id);
      if (response.status === 200) {
        this.props.questions[this.props.qid].is_bookmarked = 0
      }
    }
  };

  previousQuestion = async () => {
    let { qid, search, questions } = this.props;
    let swipeDistance;
    if ( qid == 0) return;
    this.setState({ showShimmer: true })
    setTimeout(() => {
      this.setState({ showShimmer: false })
      swipeDistance = window.innerWidth / 4;
      history.push(`/practiceTest/${parseInt(qid) - 1}${search}`);
      this.onQuestionClick(parseInt(qid), null, null, swipeDistance);

    }, 100)
  }

  nextQuestion = async () => {
    let { qid, search, questions } = this.props;
    let swipeDistance;
    if (qid == questions.length - 1) return;
    this.setState({ showShimmer: true })
    setTimeout(() => {
      this.setState({ showShimmer: false })
      swipeDistance = window.innerWidth * 3 / 4;
      history.push(`/practiceTest/${parseInt(qid) + 1}${search}`);
      this.onQuestionClick(parseInt(qid), null, null, swipeDistance);
    }, 100)
  }

  render() {
    let { search, practice_id, qid, questions, timelimit } = this.props;
    let { answers, modalOpen,testSubmittedModalOpen,windowChangeWarningModalOpen } = this.state;
    console.log(this.state.noOfWindowSwitches)
    if (!questions || !questions.length) {
      return <p>No questions</p>;
    }
    let options = questions[qid].practice_questions_options;
    let progress = ((+(qid) + 1) / questions.length) * 100;
    let greyWidth = 100 - progress;
    return (
      <div style={{backgroundColor: 'white', overflow: 'hidden'}}>
        <div style={{position: 'fixed', top: '0', left: '0', backgroundColor: 'white', width: '100%', zIndex: '1', height: '100px' }}>
          <div style={{backgroundColor: 'white', overflow: 'hidden'}}>
            <div style={{display: 'flex', flexDirection: 'row'}}>
            <div style={{margin:'auto',marginRight:'1em',marginTop: '0.5em',marginLeft: '0.8em', fontSize: '24px',fontWeight: '600', textAlign: 'left'}}>
                <img style={{width: '15px'}} src="/images/hourglass.svg"></img>&nbsp;<span id="countdown2"></span>
              </div>
              <div style={{margin: 'auto', marginRight: '1.5em'}}>
                <div className='submitButton' onClick={this.handleModalToggle}>End Test</div>
              </div>
              
            </div>

            <Flex>
              <div style={{margin: '1em 1.5em 0 1.5em', fontSize: '16px', fontWeight: '600'}}>
                  {+(qid) + 1} of {questions.length}
              </div>
              <div style={{margin: '1em 1.5em 0 auto ', width: '30px', marginRight: '1.5em', justifyContent: 'flex-end',display: 'flex', flexDirection: 'row'}}>
                {qid != 0 ? 
                  <img style={{marginRight: '20px'}} onClick={this.previousQuestion} src="/images/backArrow.svg"></img>
                  : null}
                {qid + 1 != questions.length ? 
                  <img onClick={this.nextQuestion} src="/images/frontArrow.svg"></img>
                  : null}
              </div>
            </Flex>
            <div style={{margin: '1em 1.5em'}}>
                <div style={{width: '100%', height: '6px', display: 'flex', flexDirection: 'row'}}>
                  <div className='gradient' style={{width: progress+ '%'}}></div>
                  <div className='greyProgress' style={{width: greyWidth + '%', backgroundColor: '#eee'}} ></div>

                </div>

            </div>
        </div>
        </div>
        <LayoutWrapper large={true} id="questionArea" >
          {this.state.showShimmer ? <Shimmer /> :
            <GridLayout>
              <Flex column>
                <Box>
                  <Equation blooms={questions[qid].blooms_level} math_type={questions[qid].math_type} bold equation={questions[qid].name}></Equation>
                </Box>
                {questions[qid].media === 1 && (
                  <Image center>
                    <img src={questions[qid].question_img} alt="" />
                  </Image>
                )}
                <Hint alignCenter>
                  <div style={{ cursor: "pointer" }} onClick={this.handleBookMark}>
                    <span>{answers[qid].isBookMarked ? 'Marked for review' : 'Mark for review'}</span>
                  </div>
                    <div style={{margin: 'auto', marginRight: '5px', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <div style={{ cursor: "pointer", marginRight: '10px' }}>
                      <Report testId={practice_id} questionId={questions[qid].id} ></Report>
                    </div>
                      <div style={{ cursor: "pointer", margin: '0', padding: '0' }} onClick={this.addOrDeleteBookmark}>
                          {questions[qid].is_bookmarked === 1 ?
                            <img style={{ color: 'white', width: '20px', height: '18px' }} src="/images/bookmarked.svg"></img>
                            :
                            <img style={{ color: 'white', width: '20px', height: '18px' }} src="/images/Bookmark.svg"></img>
                          }
                      </div>
                    </div>
                  </Hint>
                <div style={{display: 'flex', flexDirection: 'column', marginTop: '10px'}}>
                  {options.map(
                    ({ id, name, media, option_img, is_answer }, i) => {
                      let option_selected = answers[qid].question_option_id
                      let is_selected = true ? option_selected === id : false
                      
                      return (

                        <div key={i} onClick={() => this.handleCheck(id, is_answer)} className={ (is_answer && is_selected) ? 'correctGradient' : (!is_answer && is_selected) ? 'incorrectGradient' :  'gradient1'}>
                          {is_answer == 1 && is_selected && option_selected &&
                           <img style={{ height: '20px', position: 'absolute', right: '5px' }} src="/images/white_tick-mark.png"></img>
                          }
                          {is_answer == 1 && !is_selected && option_selected &&
                           <img style={{ height: '20px', position: 'absolute', right: '5px' }} src="/images/green_tick-mark.png"></img>
                          } 
                        {/* <div key={i} onClick={() => this.handleCheck(id, is_answer)} className={ is_selected? 'gradient2' : 'gradient1'}> */}
                        
                          <div className="qNo"><p style={{ margin: '0.2em 0' }}>{i + 1}</p></div>
                          <div style={{ paddingLeft: '30px', paddingRight: '20px' }}>
                            <Equation answered={answers[qid].question_option_id === id} math_type={questions[qid].math_type} equation={name}></Equation>
                            {media === 1 && <img src={option_img} alt="" />}
                          </div>
                        </div>)
                    }
                    )}
                </div>
                {/* {qid == questions.length - 1 &&
                  <Flex justifyEnd>
                    <Button disabled={this.state.testSubmitting} onClick={this.handleModalToggle}>Submit</Button>
                  </Flex>
                } */}

                <ActionButtons>
                  <Flex justifyBetween>
                    {qid > 0 ? (
                      <Link to={`/practiceTest/${parseFloat(qid) - 1}${search}`}>
                        <Button>Previous</Button>
                      </Link>
                    ) : (
                        <div />
                      )}
                    {questions.length - 1 > qid ? (
                      <Link to={`/practiceTest/${parseFloat(qid) + 1}${search}`}>
                        <Button>Next</Button>
                      </Link>
                    ) : (
                        <div />
                      )}
                  </Flex>
                </ActionButtons>

              </Flex>

              <QuestionOverviewWrapper>
                <Flex column>
                  <Box simple>
                    <h3>Questions overview</h3>
                    <QuestionsOverview>
                      {questions.map(({ id }, i) => (
                        <Hexagon
                          key={id}
                          center
                          active={!(i - qid)}
                          blue={Boolean(answers[i].question_option_id)}
                          yellow={Boolean(answers[i].isBookMarked)}
                          onClick={() => this.onQuestionClick(qid)}
                        >
                          <Link to={`/practiceTest/${i}${search}`}>
                            <Hex />
                            <span>{i + 1}</span>
                          </Link>
                        </Hexagon>
                      ))}
                    </QuestionsOverview>
                    <Flex center style={{ marginTop: "2em" }}>
                      <Button onClick={this.handleModalToggle}>Submit</Button>
                    </Flex>
                    <div style={{ marginTop: "2em" }}>
                      {[
                        { title: "Active Question", active: true },
                        { title: "Answered", color: "blue" },
                        { title: "Bookmarked", color: "yellow" },
                        { title: "Unanswered", color: "" }
                      ].map(({ active, color, title }) => (
                        <div key={title}>
                          <Flex alignCenter>
                            <Hexagon
                              active={active}
                              yellow={color == "yellow" ? true : false}
                              blue={color == "blue" ? true : false}
                            >
                              <a>
                                <Hex />
                              </a>
                            </Hexagon>
                            <p style={{ marginLeft: "1em" }}>{title}</p>
                          </Flex>
                        </div>
                      ))}
                    </div>
                  </Box>
                </Flex>
              </QuestionOverviewWrapper>

            </GridLayout>}



          <Modal
            open={modalOpen}
            handleModalToggle={this.handleModalToggle}
            handleSubmit={this.handleSubmit}
            dialogTitle={this.state.dialogTitle}
          />
          <Modal1
            open={testSubmittedModalOpen}
            callBack={this.testSubmittedOnLeavingWindow}
            dialogTitle={this.state.dialogTitle}
          />
          <Modal1
            open={windowChangeWarningModalOpen}
            callBack={this.windowChangeWarningModalClose}
            dialogTitle={this.state.dialogTitle}
          />
        </LayoutWrapper>
        <MobileCarousel activeQId={qid}>

          {questions.map(({ id, name, math_type }, i) => {
            let is_answered_correctly = true ? answers[i].is_answer === 1 : false
            let answered_wrong = true ? answers[i].is_answer === 0 : false
            return (
            //Handle mobile click
            <Link to={`/practiceTest/${i}${search}`} key={i}>
              <div className={i == qid ? 'mqCardActive' : 'mqCard'} onClick={(event) => this.onQuestionClick(qid, i, event)}>
                <Hexagon2
                  green = {is_answered_correctly}
                  red = {answered_wrong}
                  yellow={Boolean(answers[i].isBookMarked)}
                  qNo={i + 1}></Hexagon2>
                  {/* <Hexagon2
                  blue={Boolean(answers[i].question_option_id)}

                  yellow={Boolean(answers[i].isBookMarked)}
                  qNo={i + 1}></Hexagon2> */}
                <span>

                  <Equation answered={i == qid} math_type={math_type} equation={name.slice(1, 4) === 'pre' ? name.slice(5, 13) + '...' : name.slice(0, 8) + '...'}></Equation>
                </span>
              </div>
            </Link>
          )}
          )}
        </MobileCarousel>

        <style jsx='true' scoped>{`
          .mqCard{
            display: inline-block;
            width: 80px;
            margin: 5px;
            height: 60px;
            border: solid 1px #9E9E9E;
            border-radius: 5px;
            background: white;
            color:gray;
            transform:unset;
            box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
            span{
                position: relative;
                left: 5px;
                font-size: 11px;
                color:gray;
                pre{
                    margin:0px;
                }
            }
          }
          .incorrectGradient{
            background: url('/images/incorrectBox.svg');
            color: #313149;
            padding:12px;
            background-size: cover;
            background-repeat: no-repeat;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }
          .correctGradient{
            background: 
              url('/images/correctBox.svg');
              // url('/images/correctBox.svg') border-box;
            color: #313149;
            padding:12px;
            background-size: cover;
            background-repeat: no-repeat;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }
          .mqCardActive{
            display: inline-block;
            width: 80px;
            margin: 5px;
            height: 60px;
            border: solid 1px #9E9E9E;
            border-radius: 5px;
            background:
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
            color:white;
            transform:scale(1.1);
            box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
            span{
                position: relative;
                left: 5px;
                font-size: 11px;
                color:white;
                pre{
                    margin:0px;
                }
            }
          }
          .submitButton{
            background:
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
              margin: auto;
              float: right;
              margin-top: 12px;
              padding: 0.2em 1em;
              border-radius: 16px; 
              font-size: 16px;
              font-weight: 600;
              color: white;
              border: none;
              cursor: pointer;
              &:focus{
                outline:0;
              }
              @media (max-width: 768px) {
                display: block;
            }
          }
          .qNo{
            position: absolute;
            left: 5px;
            top: 6px;
            width: 20px;
            height: 20px;
            border-radius: 10px;
            text-align: center;
            background: #EEEEEE;
            font-size: 10px;
          }
          .gradient1{
            background: 
              linear-gradient(#fff,#fff) padding-box, 
              linear-gradient(to right bottom, #FFFFFF 0%, #4E54C8 39.777%, #DD92D8 100%) border-box;
            color: #313149;
            padding:10px;
            border: 2px solid transparent;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }

          .gradient2{
            background: 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
              linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
            color: #313149;
            padding:10px;
            border: 2px solid transparent;
            border-radius:10px;
            display:inline-block;
            margin-bottom: 10px;
            position: relative;
            text-align: center;
            height: 100%;
          }
          .gradient{
            background:linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box;
            border: 1px transparent;
            display: inline-block;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;


          }
          .greyProgress{
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
          }
        
        
        `}
        </style>
      </div>
    );
  }
}

export default TestStart;
